import {Pipe, PipeTransform} from '@angular/core';

// Calls often last less than a minute, so seconds are always shown and empty units are dropped.
export function formatCallDuration(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours}h${String(minutes).padStart(2, '0')}m${String(remainingSeconds).padStart(2, '0')}s`;
  }

  if (minutes > 0) {
    return `${minutes}m${String(remainingSeconds).padStart(2, '0')}s`;
  }

  return `${remainingSeconds}s`;
}

@Pipe({name: 'callDuration'})
export class CallDurationPipe implements PipeTransform {
  transform(seconds: number): string {
    return formatCallDuration(seconds);
  }
}
